// API Configuration - use relative URL in production (same domain), localhost in dev
export const API_URL = process.env.NODE_ENV === 'production'
  ? ''  // Same domain - no prefix needed
  : 'http://localhost:3001';

// Video upload constraints
export const VIDEO_CONSTRAINTS = {
  MAX_FILE_SIZE_MB: 10,
  MIN_DURATION_SECONDS: 3,
  MAX_DURATION_SECONDS: 10,
  SUPPORTED_TYPES: ['video/mp4', 'video/webm', 'video/quicktime', 'video/mov'],
};

// Analysis limits
export const ANALYSIS_LIMITS = {
  MAX_QUESTIONS_PER_SWING: 5,
  RATE_LIMIT_PER_HOUR: 10,
};

// FFmpeg configuration
export const FFMPEG_CONFIG = {
  OUTPUT_RESOLUTION: { width: 1280, height: 720 },
  FALLBACK_RESOLUTION: { width: 640, height: 480 },
  KEY_FRAME_POSITIONS: [0.10, 0.35, 0.60, 0.85], // 10%, 35%, 60%, 85% of video
  COMPRESSION_TIMEOUT_MS: 8000,
};
